import { formatMoney } from '@nemuru-eng/js-api-client';

import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const adjustmentsAndDisbursedAmountMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.6,
    field: 'disbursedAmount',
    headerName: <Text tId={'AMOUNT'} />,
    align: 'right',
    type: 'number',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: PayoutsListRowProps) => {
      return (
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              color: palette.text.primary,
            }}
          >
            <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.disbursedAmount))}</strong>
          </div>
          <span color={palette.text.secondary}>
            {formatMoney(amountToValueMoneyMapper(rowData.row.adjustmentsAmount))}
          </span>
        </div>
      );
    },
  };
};
